import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Error = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        textAlign: 'center',
        padding: 3
      }}
    >
      <Typography variant="h1" color="error" sx={{ mb: 2 }}>
        Oops!
      </Typography>
      <Typography variant="h5" sx={{ mb: 4 }}>
        Something went wrong. We're working on fixing it.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/dashboard')}
        sx={{
          bgcolor: '#ff4d4f',
          '&:hover': {
            bgcolor: '#ff7875'
          }
        }}
      >
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default Error;